window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Andrea_Side_Neutral_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Andrea_Side_Neutral_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,461,664);


(lib.Andrea_Side_Neutral_Open = function() {
	this.initialize(img.DialogScenes_RTL_Andrea_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,461,664);


(lib.Background_Blue = function() {
	this.initialize(img.DialogScenes_RTL_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.BG_Door = function() {
	this.initialize(img.DialogScenes_RTL_BG_Door);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1335,1340);


(lib.BIGTABLE = function() {
	this.initialize(img.DialogScenes_RTL_BIGTABLE);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1008,735);


(lib.BOARD = function() {
	this.initialize(img.DialogScenes_RTL_BOARD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,448,600);


(lib.cappuccino = function() {
	this.initialize(img.DialogScenes_RTL_cappuccino);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,134,119);


(lib.chai = function() {
	this.initialize(img.DialogScenes_RTL_chai);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,127,202);


(lib.CharacterShadow = function() {
	this.initialize(img.DialogScenes_RTL_CharacterShadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,294,163);


(lib.closedDoor = function() {
	this.initialize(img.DialogScenes_RTL_closedDoor);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,215,616);


(lib.coffee = function() {
	this.initialize(img.DialogScenes_RTL_coffee);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,134,119);


(lib.coffeemachine = function() {
	this.initialize(img.DialogScenes_RTL_coffeemachine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,369,559);


(lib.Conf1 = function() {
	this.initialize(img.DialogScenes_RTL_Conf1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,86);


(lib.Conf2 = function() {
	this.initialize(img.DialogScenes_RTL_Conf2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,86);


(lib.Couch = function() {
	this.initialize(img.DialogScenes_RTL_Couch);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1061,834);


(lib.curtains = function() {
	this.initialize(img.DialogScenes_RTL_curtains);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,791,1178);


(lib.deskfront = function() {
	this.initialize(img.DialogScenes_RTL_deskfront);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,869,858);


(lib.deskGambit2 = function() {
	this.initialize(img.DialogScenes_RTL_deskGambit2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1166,998);


(lib.dustbin01 = function() {
	this.initialize(img.DialogScenes_RTL_dustbin01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,222,269);


(lib.dustbin02 = function() {
	this.initialize(img.DialogScenes_RTL_dustbin02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,239,290);


(lib.Element1 = function() {
	this.initialize(img.DialogScenes_RTL_Element1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,78,98);


(lib.Element3 = function() {
	this.initialize(img.DialogScenes_RTL_Element3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,196,138);


(lib.Element4 = function() {
	this.initialize(img.DialogScenes_RTL_Element4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,149,86);


(lib.elevator = function() {
	this.initialize(img.DialogScenes_RTL_elevator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,578,903);


(lib.espresso = function() {
	this.initialize(img.DialogScenes_RTL_espresso);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,138,122);


(lib.Extra1_Back = function() {
	this.initialize(img.DialogScenes_RTL_Extra1_Back);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,502,668);


(lib.Extra1_Side_Back = function() {
	this.initialize(img.DialogScenes_RTL_Extra1_Side_Back);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,454,669);


(lib.Extra_Side_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Extra_Side_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,490,680);


(lib.Extra_Side_Open = function() {
	this.initialize(img.DialogScenes_RTL_Extra_Side_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,490,680);


(lib.Extra_Side_Seated = function() {
	this.initialize(img.DialogScenes_RTL_Extra_Side_Seated);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,731);


(lib.Eye_Front_Open = function() {
	this.initialize(img.DialogScenes_RTL_Eye_Front_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,32,36);


(lib.factory4b = function() {
	this.initialize(img.DialogScenes_RTL_factory4b);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,796,1566);


(lib.Flags = function() {
	this.initialize(img.DialogScenes_RTL_Flags);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,913,801);


(lib.gambit = function() {
	this.initialize(img.DialogScenes_RTL_gambit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.Gambit_Back = function() {
	this.initialize(img.DialogScenes_RTL_Gambit_Back);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,930,1113);


(lib.gambit_closed = function() {
	this.initialize(img.DialogScenes_RTL_gambit_closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.gambitanim3x = function() {
	this.initialize(img.DialogScenes_RTL_gambitanim3x);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1948,2260);


(lib.gambitanimeyes3x = function() {
	this.initialize(img.DialogScenes_RTL_gambitanimeyes3x);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,312);


(lib.gambitback = function() {
	this.initialize(img.DialogScenes_RTL_gambitback);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,342,448);


(lib.GREENPOSTITS = function() {
	this.initialize(img.DialogScenes_RTL_GREENPOSTITS);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,93);


(lib.Ground_Iso = function() {
	this.initialize(img.DialogScenes_RTL_Ground_Iso);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1335,1539);


(lib.Ground_Straight = function() {
	this.initialize(img.DialogScenes_RTL_Ground_Straight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,1568);


(lib.james = function() {
	this.initialize(img.DialogScenes_RTL_james);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,664);


(lib.James_Side_Neutral_Closed = function() {
	this.initialize(img.DialogScenes_RTL_James_Side_Neutral_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,664);


(lib.Kastje = function() {
	this.initialize(img.DialogScenes_RTL_Kastje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,517,538);


(lib.Man1_Brow = function() {
	this.initialize(img.DialogScenes_RTL_Man1_Brow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,52,10);


(lib.Man1_Front_Base = function() {
	this.initialize(img.DialogScenes_RTL_Man1_Front_Base);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,441,655);


(lib.Man2_Brow = function() {
	this.initialize(img.DialogScenes_RTL_Man2_Brow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,52,10);


(lib.Man2_Front_Base = function() {
	this.initialize(img.DialogScenes_RTL_Man2_Front_Base);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,442,655);


(lib.Man2_Moustache = function() {
	this.initialize(img.DialogScenes_RTL_Man2_Moustache);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,219,79);


(lib.megan = function() {
	this.initialize(img.DialogScenes_RTL_megan);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,664);


(lib.Megan_Side_Angry_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Megan_Side_Angry_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,663);


(lib.Megan_Side_Angry_Open = function() {
	this.initialize(img.DialogScenes_RTL_Megan_Side_Angry_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,663);


(lib.Megan_Side_Neutral_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Megan_Side_Neutral_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,664);


(lib.Megan_Side_Sitting_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Megan_Side_Sitting_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,552,607);


(lib.Megan_Side_Sitting_Open = function() {
	this.initialize(img.DialogScenes_RTL_Megan_Side_Sitting_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,552,607);


(lib.officeviewfloor = function() {
	this.initialize(img.DialogScenes_RTL_officeviewfloor);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,833);


(lib.openDoor = function() {
	this.initialize(img.DialogScenes_RTL_openDoor);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,432,620);


(lib.PAPER = function() {
	this.initialize(img.DialogScenes_RTL_PAPER);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,102);


(lib.Plant1 = function() {
	this.initialize(img.DialogScenes_RTL_Plant1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,161,374);


(lib.Plant2 = function() {
	this.initialize(img.DialogScenes_RTL_Plant2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,95,160);


(lib.Plant3 = function() {
	this.initialize(img.DialogScenes_RTL_Plant3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,54,114);


(lib.Plant4 = function() {
	this.initialize(img.DialogScenes_RTL_Plant4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,523,718);


(lib.Plant5 = function() {
	this.initialize(img.DialogScenes_RTL_Plant5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,789);


(lib.profits = function() {
	this.initialize(img.DialogScenes_RTL_profits);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,351,471);


(lib.robert = function() {
	this.initialize(img.DialogScenes_RTL_robert);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,663);


(lib.Robert_Side_Neutral_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Robert_Side_Neutral_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,663);


(lib.Robert_Side_Sad_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Robert_Side_Sad_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,663);


(lib.Robert_Side_Sad_Open = function() {
	this.initialize(img.DialogScenes_RTL_Robert_Side_Sad_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,663);


(lib.Robert_Side_Sitting_Closed = function() {
	this.initialize(img.DialogScenes_RTL_Robert_Side_Sitting_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,461,602);


(lib.Robert_Side_Sitting_Open = function() {
	this.initialize(img.DialogScenes_RTL_Robert_Side_Sitting_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,461,602);


(lib.Scene1_Table = function() {
	this.initialize(img.DialogScenes_RTL_Scene1_Table);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,839,638);


(lib.Shadow_Front = function() {
	this.initialize(img.DialogScenes_RTL_Shadow_Front);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,700,741);


(lib.SmallTable = function() {
	this.initialize(img.DialogScenes_RTL_SmallTable);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,505,441);


(lib.smoothy = function() {
	this.initialize(img.DialogScenes_RTL_smoothy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,306);


(lib.Spot_01 = function() {
	this.initialize(img.DialogScenes_RTL_Spot_01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,470,1161);


(lib.Spot_02 = function() {
	this.initialize(img.DialogScenes_RTL_Spot_02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,737,1250);


(lib.STOOL = function() {
	this.initialize(img.DialogScenes_RTL_STOOL);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,222,234);


(lib.Table_Empty = function() {
	this.initialize(img.DialogScenes_RTL_Table_Empty);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,839,638);


(lib.water = function() {
	this.initialize(img.DialogScenes_RTL_water);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,127,195);


(lib.watercooler01 = function() {
	this.initialize(img.DialogScenes_RTL_watercooler01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,349,724);


(lib.watercoolerfloor01 = function() {
	this.initialize(img.DialogScenes_RTL_watercoolerfloor01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,1043);


(lib.window = function() {
	this.initialize(img.DialogScenes_RTL_window);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,562,906);


(lib.wine = function() {
	this.initialize(img.DialogScenes_RTL_wine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,134,223);


(lib.Woman1_Brow = function() {
	this.initialize(img.DialogScenes_RTL_Woman1_Brow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,53,10);


(lib.Woman1_Front_Base = function() {
	this.initialize(img.DialogScenes_RTL_Woman1_Front_Base);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,441,729);


(lib.Woman2_Brow = function() {
	this.initialize(img.DialogScenes_RTL_Woman2_Brow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,52,10);


(lib.Woman2_Front_Base = function() {
	this.initialize(img.DialogScenes_RTL_Woman2_Front_Base);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,443,655);


(lib.YELLOWPOSTIS = function() {
	this.initialize(img.DialogScenes_RTL_YELLOWPOSTIS);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,98);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.wine_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.wine();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.wine_1, new cjs.Rectangle(0,0,134,223), null);


(lib.window_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.window();
	this.instance.setTransform(-281,-453);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.window_1, new cjs.Rectangle(-281,-453,562,906), null);


(lib.watercooler = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.watercooler01();
	this.instance.setTransform(0,0,0.8655,0.8655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.watercooler, new cjs.Rectangle(0,0,302.1,626.7), null);


(lib.water_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.water();
	this.instance.setTransform(4,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.water_1, new cjs.Rectangle(4,0,127,195), null);


(lib.Table_Empty_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Table_Empty();
	this.instance.setTransform(-340,-331);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Table_Empty_1, new cjs.Rectangle(-340,-331,839,638), null);


(lib.Symbol1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterShadow();
	this.instance.setTransform(-174.95,-97,1.19,1.19);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Symbol1, new cjs.Rectangle(-174.9,-97,349.8,194), null);


(lib.stool = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.STOOL();
	this.instance.setTransform(-111,-117);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.stool, new cjs.Rectangle(-111,-117,222,234), null);


(lib.Spotlight1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Spot_01();
	this.instance.setTransform(-235,-1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Spotlight1, new cjs.Rectangle(-235,-1,470,1161), null);


(lib.Spotlight_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Spot_02();
	this.instance.setTransform(-705,-16);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Spotlight_01, new cjs.Rectangle(-705,-16,737,1250), null);


(lib.smoothie = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.smoothy();
	this.instance.setTransform(0,0,0.6701,0.6701);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.smoothie, new cjs.Rectangle(0,0,91.8,205.1), null);


(lib.SmallTable_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SmallTable();
	this.instance.setTransform(-253,-360);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmallTable_1, new cjs.Rectangle(-253,-360,505,441), null);


(lib.ShadowJump = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CharacterShadow();
	this.instance.setTransform(-147,-81.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShadowJump, new cjs.Rectangle(-147,-81.5,294,163), null);


(lib.Scene1_Table_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Scene1_Table();
	this.instance.setTransform(-419.5,-319);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Scene1_Table_1, new cjs.Rectangle(-419.5,-319,839,638), null);


(lib.Robert_Side_Sitting = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Robert_Side_Sitting_Open();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Robert_Side_Sitting_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},159).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},330).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-570,-1776,1344.3,1755.4);


(lib.Robert_Side_Sad = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Robert_Side_Sad_Open();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Robert_Side_Sad_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},159).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},330).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1776,1763.9,2265);


(lib.Robert_Side_NoShadow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.robert();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Robert_Side_Neutral_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},159).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},330).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-570,-1776,1347.2,1933.3);


(lib.Robert_Side_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.robert();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Robert_Side_Neutral_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},159).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},330).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1776,1763.9,2265);


(lib.Profits = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.profits();
	this.instance.setTransform(-175.5,-235.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Profits, new cjs.Rectangle(-175.5,-235.5,351,471), null);


(lib.PlateGreen_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Element4();
	this.instance.setTransform(-74.5,-43);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlateGreen_01, new cjs.Rectangle(-74.5,-43,149,86), null);


(lib.Plant_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant5();
	this.instance.setTransform(-273,-755);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plant_5, new cjs.Rectangle(-273,-755,586,789), null);


(lib.Plant_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant4();
	this.instance.setTransform(-262,-684);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plant_4, new cjs.Rectangle(-262,-684,523,718), null);


(lib.Plant_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant3();
	this.instance.setTransform(-27,-103);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plant_3, new cjs.Rectangle(-27,-103,54,114), null);


(lib.Plant_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant2();
	this.instance.setTransform(-47,-144);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plant_2, new cjs.Rectangle(-47,-144,95,160), null);


(lib.Plant_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant1();
	this.instance.setTransform(-80,-352);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plant_1, new cjs.Rectangle(-80,-352,161,374), null);


(lib.Megan_Side_Sitting01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Megan_Side_Sitting_Open();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Megan_Side_Sitting_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},359).to({state:[{t:this.instance}]},15).to({state:[{t:this.instance}]},125).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-570,-1776,1609.6,1770);


(lib.Megan_Side_NoShadow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.megan();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Megan_Side_Neutral_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},359).to({state:[{t:this.instance}]},15).to({state:[{t:this.instance}]},125).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-570,-1776,1612.5,1936.2);


(lib.Megan_Side_Angry_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Megan_Side_Angry_Open();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Megan_Side_Angry_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},359).to({state:[{t:this.instance}]},15).to({state:[{t:this.instance}]},125).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1776,1924.5,2265);


(lib.Megan_Side_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.megan();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Megan_Side_Neutral_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},359).to({state:[{t:this.instance}]},15).to({state:[{t:this.instance}]},125).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1776,1924.5,2265);


(lib.Kastje_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Kastje();
	this.instance.setTransform(-218,-358);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Kastje_1, new cjs.Rectangle(-218,-358,517,538), null);


(lib.James_Side_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.james();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.James_Side_Neutral_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},309).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},180).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1776,1763.9,2265);


(lib.GambitEyes = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambitanimeyes3x();
	this.instance.setTransform(-216.5,-156);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},31).wait(9).to({_off:false},0).to({_off:true},39).wait(8).to({_off:false},0).wait(566));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-216.5,-156,433,312);


(lib.GambitBack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambitback();
	this.instance.setTransform(-212,-267,0.8237,0.8237);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow();
	this.instance_1.setTransform(-249,-26,1.1724,1.1724);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GambitBack, new cjs.Rectangle(-249,-267,344.7,432.1), null);


(lib.Gambit_NoShadow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit();
	this.instance.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_1 = new lib.gambit_closed();
	this.instance_1.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},189).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},300).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-132,-297,239.7,320);


(lib.Gambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit();
	this.instance.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_1 = new lib.gambit_closed();
	this.instance_1.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},189).to({state:[{t:this.instance}]},10).to({state:[{t:this.instance}]},300).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-147,-82);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-147,-297,294,378);


(lib.FlaskGreen01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Element1();
	this.instance.setTransform(-39,-78);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FlaskGreen01, new cjs.Rectangle(-39,-78,78,98), null);


(lib.Flags_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Flags();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Flags_1, new cjs.Rectangle(0,0,913,801), null);


(lib.factory4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory4b();
	this.instance.setTransform(-398,-786.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory4, new cjs.Rectangle(-398,-786.5,796,1566), null);


(lib.Eyes_Blinking = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Eye_Front_Open();
	this.instance.setTransform(44,-18);

	this.instance_1 = new lib.Eye_Front_Open();
	this.instance_1.setTransform(-76,-18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]}).to({state:[{t:this.instance_1,p:{scaleY:0.1389,y:-3}},{t:this.instance,p:{scaleY:0.1389,y:-3}}]},119).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]},10).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]},370).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76,-18,152,36);


(lib.ExtraJumping = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Extra1_Side_Back();
	this.instance.setTransform(-123,-339,0.5426,0.5427);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ExtraJumping, new cjs.Rectangle(-123,-339,246.4,363.1), null);


(lib.Extra1_Side_NoShadow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Extra_Side_Open();
	this.instance.setTransform(-580,-1779,2.8474,2.8474);

	this.instance_1 = new lib.Extra_Side_Closed();
	this.instance_1.setTransform(-580,-1779,2.8474,2.8474);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},499).wait(15));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-580,-1779,1395.2,1936.2);


(lib.Extra1_Side_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Extra_Side_Open();
	this.instance.setTransform(-580,-1779,2.8474,2.8474);

	this.instance_1 = new lib.Extra_Side_Closed();
	this.instance_1.setTransform(-580,-1779,2.8474,2.8474);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},499).wait(15));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(514));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1779,1763.9,2268);


(lib.Extra1_Back_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Extra1_Back();
	this.instance.setTransform(-671,-1779,2.8474,2.8474);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.CharacterShadow();
	this.instance_1.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Extra1_Back_01, new cjs.Rectangle(-882,-1779,1763.9,2268), null);


(lib.espresso_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.espresso();
	this.instance.setTransform(0,32,0.7431,0.7431);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.espresso_1, new cjs.Rectangle(0,32,102.6,90.7), null);


(lib.Ellis_Side_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Andrea_Side_Neutral_Open();
	this.instance.setTransform(-570,-1776,2.9159,2.9159);

	this.instance_1 = new lib.Andrea_Side_Neutral_Closed();
	this.instance_1.setTransform(-570,-1776,2.9159,2.9159);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},439).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},15).to({state:[{t:this.instance}]},44).wait(1));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-882,-489,5.9997,5.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-882,-1776,1763.9,2265);


(lib.Elevator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.elevator();
	this.instance.setTransform(-325,-765);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Elevator, new cjs.Rectangle(-325,-765,578,903), null);


(lib.dustbin2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.dustbin02();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.dustbin2, new cjs.Rectangle(0,0,239,290), null);


(lib.dustbin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.dustbin01();
	this.instance.setTransform(0,0,0.8821,0.8821);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.dustbin, new cjs.Rectangle(0,0,195.9,237.3), null);


(lib.Door1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.closedDoor();
	this.instance.setTransform(-107,-556);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Door1, new cjs.Rectangle(-107,-556,215,616), null);


(lib.Doo2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.openDoor();
	this.instance.setTransform(-325,-560);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Doo2, new cjs.Rectangle(-325,-560,432,620), null);


(lib.deskGambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.deskGambit2();
	this.instance.setTransform(-582.5,-539);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.deskGambit, new cjs.Rectangle(-582.5,-539,1166,998), null);


(lib.desk01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.deskfront();
	this.instance.setTransform(-434.5,-429);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.desk01, new cjs.Rectangle(-434.5,-429,869,858), null);


(lib.curtains_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.curtains();
	this.instance.setTransform(-381.1,-569.9,0.9636,0.9676);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.curtains_1, new cjs.Rectangle(-381.1,-569.9,762.2,1139.9), null);


(lib.Couch_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Couch();
	this.instance.setTransform(-424,-450);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Couch_1, new cjs.Rectangle(-424,-450,1061,834), null);


(lib.Conf2_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Conf2();
	this.instance.setTransform(-74.5,-43);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Conf2_1, new cjs.Rectangle(-74.5,-43,149,86), null);


(lib.Conf1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Conf1();
	this.instance.setTransform(-74.5,-43);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Conf1_1, new cjs.Rectangle(-74.5,-43,149,86), null);


(lib.coffeemachine_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.coffeemachine();
	this.instance.setTransform(-184.5,-279.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.coffeemachine_1, new cjs.Rectangle(-184.5,-279.5,369,559), null);


(lib.coffee_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.coffee();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.coffee_1, new cjs.Rectangle(0,0,134,119), null);


(lib.chai_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.chai();
	this.instance.setTransform(0,1,0.7583,0.7583);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.chai_1, new cjs.Rectangle(0,1,96.3,153.2), null);


(lib.cappuccino_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.cappuccino();
	this.instance.setTransform(0,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.cappuccino_1, new cjs.Rectangle(0,1,134,119), null);


(lib.board = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BOARD();
	this.instance.setTransform(-224,-300);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.board, new cjs.Rectangle(-224,-300,448,600), null);


(lib.bigtable = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.GREENPOSTITS();
	this.instance.setTransform(-149,-235,0.8285,0.8285);

	this.instance_1 = new lib.YELLOWPOSTIS();
	this.instance_1.setTransform(-125,-124,0.8285,0.8285);

	this.instance_2 = new lib.PAPER();
	this.instance_2.setTransform(155,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Layer_1
	this.instance_3 = new lib.BIGTABLE();
	this.instance_3.setTransform(-504,-368);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bigtable, new cjs.Rectangle(-504,-368,1008,735), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.Award = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Element3();
	this.instance.setTransform(-132,-36);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Award, new cjs.Rectangle(-132,-36,196,138), null);


(lib.Background_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhtfCksMAC9lJXMDYCAAAMgC9FJXg");
	this.shape.setTransform(9.475,-0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-666,-1054,1.3643,1.0273);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background_1, new cjs.Rectangle(-691.3,-1055,1401.6,2110), null);


(lib.Robert_Side_Dancing_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Robert_Side_NoShadow();
	this.instance.setTransform(-0.85,-1.25,0.181,0.181,0,0,0,-0.3,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:-0.6,regY:-0.2,scaleX:0.185,scaleY:0.185},11).to({scaleX:0.19,scaleY:0.19},3).to({regX:-0.3,regY:-0.6,scaleX:0.181,scaleY:0.181,rotation:1.9954,y:-31.65},14,cjs.Ease.cubicOut).to({regX:-0.6,scaleX:0.182,scaleY:0.182,rotation:0,y:-1.25},13,cjs.Ease.quadInOut).to({scaleX:0.175,scaleY:0.175},3).to({regX:-0.3,regY:-0.3,scaleX:0.181,scaleY:0.181},8).wait(38));

	// Layer_2
	this.instance_1 = new lib.ShadowJump();
	this.instance_1.setTransform(-1,-1.5);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(14).to({scaleX:0.9,scaleY:0.9,x:-0.95,y:-1.45,alpha:0.5},14).to({scaleX:1,scaleY:1,x:-1,y:-1.5,alpha:0.8008},16).wait(46));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148,-356.4,299,436.4);


(lib.Robert_Front_Sad = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Man1_Brow();
	this.instance.setTransform(-92.9,-36.75,1,1,-11.9985);

	this.instance_1 = new lib.Man1_Brow();
	this.instance_1.setTransform(50.65,-46.75,1,1,9.9983);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-19.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Man1_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Shadow
	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_Front_Sad, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Robert_Front_Relieved = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Man1_Brow();
	this.instance.setTransform(-89.65,-109.2,1,1,-6.9994);

	this.instance_1 = new lib.Man1_Brow();
	this.instance_1.setTransform(44.95,-115.55,1,1,6.9994);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(2.15,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Man1_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_Front_Relieved, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Robert_Front_Neutral = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Man1_Brow();
	this.instance.setTransform(-82,-109);

	this.instance_1 = new lib.Man1_Brow();
	this.instance_1.setTransform(39,-109);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(2.15,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Man1_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_Front_Neutral, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Robert_Front_Anger = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Man1_Brow();
	this.instance.setTransform(-88.5,-90.65,1,1,6.9994);

	this.instance_1 = new lib.Man1_Brow();
	this.instance_1.setTransform(43.7,-84.5,1,1,-6.9994);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(2.15,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Man1_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_Front_Anger, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Megan_Side_Dancing_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Megan_Side_NoShadow();
	this.instance.setTransform(-0.85,-1.25,0.181,0.181,0,0,0,-0.3,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(26).to({scaleX:0.175,scaleY:0.175},4).to({regY:-0.8,scaleX:0.185,scaleY:0.185,rotation:1.9948,y:-31.65},14,cjs.Ease.cubicOut).to({regY:-0.3,scaleX:0.181,scaleY:0.181,rotation:0,y:-1.25},14,cjs.Ease.cubicInOut).to({scaleX:0.175,scaleY:0.175},3).to({scaleX:0.181,scaleY:0.181},5).wait(24));

	// Layer_2
	this.instance_1 = new lib.ShadowJump();
	this.instance_1.setTransform(-1,-1.5);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(29).to({scaleX:0.9,scaleY:0.9,x:-0.95,y:-1.45,alpha:0.5},14).to({scaleX:1,scaleY:1,x:-1,y:-1.5,alpha:0.8008},16).wait(31));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148,-363.6,351.4,443.6);


(lib.Megan_Front_Neutral = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman1_Brow();
	this.instance.setTransform(-82,-109);

	this.instance_1 = new lib.Woman1_Brow();
	this.instance_1.setTransform(39,-109);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman1_Front_Base();
	this.instance_3.setTransform(-220,-402);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_Front_Neutral, new cjs.Rectangle(-353,-402,700,1096), null);


(lib.Megan_Front_Frustrated = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman1_Brow();
	this.instance.setTransform(-80.6,-109.9,1,1,10.0003);

	this.instance_1 = new lib.Woman1_Brow();
	this.instance_1.setTransform(38.5,-72.15,1,1,-9.9997);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-54);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman1_Front_Base();
	this.instance_3.setTransform(-220,-402);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_Front_Frustrated, new cjs.Rectangle(-353,-402,700,1096), null);


(lib.Megan_Front_Disappointed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman1_Brow();
	this.instance.setTransform(-89.4,-80.95,1,1,-15);

	this.instance_1 = new lib.Woman1_Brow();
	this.instance_1.setTransform(48.15,-94.65,1,1,15.0005);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman1_Front_Base();
	this.instance_3.setTransform(-220,-402);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_Front_Disappointed, new cjs.Rectangle(-353,-402,700,1096), null);


(lib.Megan_Front_Angry = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman1_Brow();
	this.instance.setTransform(-80.25,-78.25,1,1,15);

	this.instance_1 = new lib.Woman1_Brow();
	this.instance_1.setTransform(37.15,-64.55,1,1,-15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-51);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman1_Front_Base();
	this.instance_3.setTransform(-220,-402);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_Front_Angry, new cjs.Rectangle(-353,-402,700,1096), null);


(lib.James_Front_Surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Moustache
	this.instance = new lib.Man2_Moustache();
	this.instance.setTransform(-101.6,-24.65,1,1,5.0001);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Brows
	this.instance_1 = new lib.Man2_Brow();
	this.instance_1.setTransform(-82.3,-111.05,1,1,-11.9993);

	this.instance_2 = new lib.Man2_Brow();
	this.instance_2.setTransform(40.6,-121.8,1,1,11.9985);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// Eyes
	this.instance_3 = new lib.Eyes_Blinking();
	this.instance_3.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Base
	this.instance_4 = new lib.Man2_Front_Base();
	this.instance_4.setTransform(-220.5,-327.5);

	this.instance_5 = new lib.Shadow_Front();
	this.instance_5.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_Front_Surprised, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.James_Front_Frustrated = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Moustache
	this.instance = new lib.Man2_Moustache();
	this.instance.setTransform(-105.9,11.05,1,1,-12.9997);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Brows
	this.instance_1 = new lib.Man2_Brow();
	this.instance_1.setTransform(-81.35,-118.75,1,1,4.9987);

	this.instance_2 = new lib.Man2_Brow();
	this.instance_2.setTransform(38.65,-85.35,1,1,-4.9992);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// Eyes
	this.instance_3 = new lib.Eyes_Blinking();
	this.instance_3.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Base
	this.instance_4 = new lib.Man2_Front_Base();
	this.instance_4.setTransform(-220.5,-327.5);

	this.instance_5 = new lib.Shadow_Front();
	this.instance_5.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_Front_Frustrated, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.James_Front_Disappointed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Moustache
	this.instance = new lib.Man2_Moustache();
	this.instance.setTransform(-110,19);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Brows
	this.instance_1 = new lib.Man2_Brow();
	this.instance_1.setTransform(-82.3,-34.65,1,1,-11.9993);

	this.instance_2 = new lib.Man2_Brow();
	this.instance_2.setTransform(40.6,-45.4,1,1,11.9985);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// Eyes
	this.instance_3 = new lib.Eyes_Blinking();
	this.instance_3.setTransform(4,-18);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Base
	this.instance_4 = new lib.Man2_Front_Base();
	this.instance_4.setTransform(-220.5,-327.5);

	this.instance_5 = new lib.Shadow_Front();
	this.instance_5.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_Front_Disappointed, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.James_Front_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Moustache
	this.instance = new lib.Man2_Moustache();
	this.instance.setTransform(-110,-18);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Brows
	this.instance_1 = new lib.Man2_Brow();
	this.instance_1.setTransform(-82,-109);

	this.instance_2 = new lib.Man2_Brow();
	this.instance_2.setTransform(39,-109);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// Eyes
	this.instance_3 = new lib.Eyes_Blinking();
	this.instance_3.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Base
	this.instance_4 = new lib.Man2_Front_Base();
	this.instance_4.setTransform(-220.5,-327.5);

	this.instance_5 = new lib.Shadow_Front();
	this.instance_5.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_Front_01, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.gambitZoomAnim = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.GambitEyes();
	this.instance.setTransform(-369.5,-270);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_1
	this.instance_1 = new lib.gambitanim3x();
	this.instance_1.setTransform(-974,-1130);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gambitZoomAnim, new cjs.Rectangle(-974,-1130,1948,2260), null);


(lib.Gambit_Side_Dancing_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Gambit_NoShadow();
	this.instance.setTransform(-0.85,-1.25,0.97,0.97,0,0,0,-0.3,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:-0.4,regY:-0.4,scaleX:1.0298,scaleY:1.0298,rotation:-1.9988,y:-31.65},14,cjs.Ease.quartOut).to({regX:-0.3,regY:-0.3,scaleX:1,scaleY:1,rotation:0,y:-1.25},14,cjs.Ease.quadInOut).to({scaleX:0.97,scaleY:0.97},2).to({scaleX:1,scaleY:1},4).to({regX:-0.4,regY:-0.4,x:-0.9,y:-1.3},52).to({regX:-0.3,regY:-0.3,scaleX:0.97,scaleY:0.97,x:-0.85,y:-1.25},3).wait(1));

	// Layer_2
	this.instance_1 = new lib.ShadowJump();
	this.instance_1.setTransform(-1,-1.5);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:0.9,scaleY:0.9,x:-0.95,y:-1.45,alpha:0.5},14).to({scaleX:1,scaleY:1,x:-1,y:-1.5,alpha:0.8008},16).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148,-340.8,294,420.8);


(lib.Extra2_Side_Dancing_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ExtraJumping();
	this.instance.setTransform(-0.8,-1.2,0.97,0.97);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1},5).wait(50).to({scaleX:0.97,scaleY:0.97},4).to({regX:-0.1,regY:-0.1,scaleX:1.0299,scaleY:1.0299,rotation:-1.8127,x:-0.85,y:-31.65},14).to({regX:0,regY:0,scaleX:1,scaleY:1,rotation:0,x:-0.8,y:-1.2},14).to({scaleX:0.97,scaleY:0.97},2).wait(1));

	// Layer_2
	this.instance_1 = new lib.ShadowJump();
	this.instance_1.setTransform(-1,-1.5);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(59).to({scaleX:0.9,scaleY:0.9,x:-0.95,y:-1.45,alpha:0.5},14).to({scaleX:1,scaleY:1,x:-1,y:-1.5,alpha:0.8008},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148,-384.5,294,464.5);


(lib.Extra1_Side_Dancing_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Extra1_Side_NoShadow();
	this.instance.setTransform(-0.85,-1.25,0.181,0.181,0,0,0,-0.3,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(41).to({scaleX:0.175,scaleY:0.175},4).to({regY:-0.8,scaleX:0.185,scaleY:0.185,rotation:1.8106,y:-31.65},14,cjs.Ease.cubicOut).to({regY:-0.3,scaleX:0.181,scaleY:0.181,rotation:0,y:-1.25},14,cjs.Ease.cubicInOut).to({scaleX:0.175,scaleY:0.175},2).to({scaleX:0.181,scaleY:0.181},4).wait(11));

	// Layer_2
	this.instance_1 = new lib.ShadowJump();
	this.instance_1.setTransform(-1,-1.5);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(44).to({scaleX:0.9,scaleY:0.9,x:-0.95,y:-1.45,alpha:0.5},14).to({scaleX:1,scaleY:1,x:-1,y:-1.5,alpha:0.8008},16).wait(16));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148,-363.8,308.3,443.8);


(lib.Extra_Side_Seated_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Extra_Side_Seated();
	this.instance.setTransform(-124,-380,0.5426,0.5427);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.Symbol1();
	this.instance_1.setTransform(-3.05,-4);
	this.instance_1.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Extra_Side_Seated_01, new cjs.Rectangle(-178,-380,349.9,473), null);


(lib.Ellis_Front_Surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman2_Brow();
	this.instance.setTransform(-82.3,-114.2,1,1,-5.0002);

	this.instance_1 = new lib.Woman2_Brow();
	this.instance_1.setTransform(39.55,-118.7,1,1,5.0002);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman2_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_Front_Surprised, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Ellis_Front_Asking = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman2_Brow();
	this.instance.setTransform(-82.3,-96.2,1,1,-5.0002);

	this.instance_1 = new lib.Woman2_Brow();
	this.instance_1.setTransform(39.55,-118.7,1,1,5.0002);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman2_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_Front_Asking, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Ellis_Front_Annoyed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman2_Brow();
	this.instance.setTransform(-82,-89);

	this.instance_1 = new lib.Woman2_Brow();
	this.instance_1.setTransform(39,-89);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman2_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_Front_Annoyed, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.Ellis_Front_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Woman2_Brow();
	this.instance.setTransform(-82,-109);

	this.instance_1 = new lib.Woman2_Brow();
	this.instance_1.setTransform(39,-109);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(4,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Woman2_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_Front_01, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.WaterEllis2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem10 = new lib.Plant_3();
	this.elem10.name = "elem10";
	this.elem10.setTransform(-191.75,-145.55,1,1,0,0,0,0,-46);

	this.elem9 = new lib.Plant_1();
	this.elem9.name = "elem9";
	this.elem9.setTransform(-108.65,-188.65,0.6012,0.6012,0,0,0,0.5,-164.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem9},{t:this.elem10}]}).wait(1));

	// Layer_2
	this.instance = new lib.water_1();
	this.instance.setTransform(-47.8,469.15,0.4473,0.4473,0,0,0,67.5,97.5);

	this.elem3 = new lib.Ellis_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-159.65,561.4,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(283.35,634.85,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem3},{t:this.instance}]}).wait(1));

	// Layer_3
	this.elem7 = new lib.watercooler();
	this.elem7.name = "elem7";
	this.elem7.setTransform(108.35,119,0.8462,0.8462,0,0,0,151,313.3);

	this.elem5 = new lib.Kastje_1();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-173.4,105.55,0.8344,0.8344);

	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(399.7,409.9);

	this.instance_1 = new lib.Ground_Iso();
	this.instance_1.setTransform(672.9,-201,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.elem8},{t:this.elem5},{t:this.elem7}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.WaterEllis2, new cjs.Rectangle(-667.5,-1184.2,1746.9,2528), null);


(lib.SceneDialog5cutscene = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem13 = new lib.Plant_5();
	this.elem13.name = "elem13";
	this.elem13.setTransform(-527.15,986.15,0.81,0.81);

	this.elem10 = new lib.Flags_1();
	this.elem10.name = "elem10";
	this.elem10.setTransform(-686,-1068.4);

	this.elem7 = new lib.FlaskGreen01();
	this.elem7.name = "elem7";
	this.elem7.setTransform(309.35,463.4);

	this.elem9 = new lib.Award();
	this.elem9.name = "elem9";
	this.elem9.setTransform(111.85,453.05);

	this.elem8 = new lib.PlateGreen_01();
	this.elem8.name = "elem8";
	this.elem8.setTransform(68.6,407.45);

	this.elem5 = new lib.Robert_Side_Dancing_01();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-107.85,279.25,1,1.0001,0,0,180);

	this.elem4 = new lib.Extra1_Side_Dancing_01();
	this.elem4.name = "elem4";
	this.elem4.setTransform(438.1,757.4,0.9999,1);

	this.elem6 = new lib.Extra2_Side_Dancing_01();
	this.elem6.name = "elem6";
	this.elem6.setTransform(-166.4,608.95,1,1,0,0,0,1.4,-181.7);

	this.elem1 = new lib.Table_Empty_1();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-75.25,434.9);

	this.elem3 = new lib.Megan_Side_Dancing_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(301.05,338.85,1,1.0001);

	this.elem12 = new lib.Spotlight_01();
	this.elem12.name = "elem12";
	this.elem12.setTransform(737.9,-798.65);

	this.elem2 = new lib.Gambit_Side_Dancing_01();
	this.elem2.name = "elem2";
	this.elem2.setTransform(-370.75,48.1);

	this.elem11 = new lib.Spotlight1();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-388,-1053);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11},{t:this.elem2},{t:this.elem12},{t:this.elem3},{t:this.elem1},{t:this.elem6},{t:this.elem4},{t:this.elem5},{t:this.elem8},{t:this.elem9},{t:this.elem7},{t:this.elem10},{t:this.elem13}]}).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(672.95,-491,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SceneDialog5cutscene, new cjs.Rectangle(-748.3,-1184.2,1827.7,2239.2), null);


(lib.SceneDialog4cutscene = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.elem11 = new lib.Extra_Side_Seated_01();
	this.elem11.name = "elem11";
	this.elem11.setTransform(74.6,713.05,1,1,0,0,180,1.4,-181.7);

	this.elem9 = new lib.Robert_Side_Sitting();
	this.elem9.name = "elem9";
	this.elem9.setTransform(431.3,246.8,0.1809,0.1809,0,0,0,236.1,-809.1);

	this.elem8 = new lib.Megan_Side_Sitting01();
	this.elem8.name = "elem8";
	this.elem8.setTransform(240.55,136.9,0.1809,0.1809,0,0,0,236.1,-809.1);

	this.elem3 = new lib.Megan_Side_Angry_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(352.35,5120.35,0.181,0.181,0,0,0,236.2,-807.9);

	this.elem10 = new lib.Extra1_Back_01();
	this.elem10.name = "elem10";
	this.elem10.setTransform(323,711.5,0.1809,0.181,0,0,0,0,0.6);

	this.elem12 = new lib.Plant_4();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-475.15,858.65);

	this.elem6 = new lib.Gambit();
	this.elem6.name = "elem6";
	this.elem6.setTransform(-95.05,285.45);

	this.elem7 = new lib.Couch_1();
	this.elem7.name = "elem7";
	this.elem7.setTransform(221,196.3);

	this.elem5 = new lib.Ellis_Side_01();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-126.6,-213.9,0.181,0.181,0,0,0,236.2,-807.9);

	this.instance = new lib.openDoor();
	this.instance.setTransform(-413,-711);

	this.elem4 = new lib.Plant_3();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-478.15,-439.55,0.6,0.6,0,0,0,-0.1,-0.1);

	this.elem3_1 = new lib.Plant_2();
	this.elem3_1.name = "elem3_1";
	this.elem3_1.setTransform(-433.75,-454.9,0.6,0.6,0,0,0,-0.1,0);

	this.elem2 = new lib.Plant_1();
	this.elem2.name = "elem2";
	this.elem2.setTransform(-483.85,-482.15,0.6,0.6,0,0,0,-0.1,-0.1);

	this.elem1 = new lib.Kastje_1();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-454.25,-310.9,0.6,0.6,0,0,0,-0.1,-0.1);

	this.instance_1 = new lib.Ground_Iso();
	this.instance_1.setTransform(672.9,-491,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.elem1},{t:this.elem2},{t:this.elem3_1},{t:this.elem4},{t:this.instance},{t:this.elem5},{t:this.elem7},{t:this.elem6},{t:this.elem12},{t:this.elem10},{t:this.elem3},{t:this.elem8},{t:this.elem9},{t:this.elem11}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SceneDialog4cutscene, new cjs.Rectangle(-737.1,-1184.2,1816.5,6539.3), null);


(lib.SceneDialog3cutscene = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem7 = new lib.Plant_5();
	this.elem7.name = "elem7";
	this.elem7.setTransform(441.25,942.75,0.81,0.81);

	this.elem5 = new lib.Conf2_1();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-36.7,489.6);

	this.elem6 = new lib.Conf1_1();
	this.elem6.name = "elem6";
	this.elem6.setTransform(15.15,389.55);

	this.elem4 = new lib.SmallTable_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-20.95,657.15);

	this.elem2 = new lib.Robert_Side_Sad();
	this.elem2.name = "elem2";
	this.elem2.setTransform(-266.2,304.6,0.1809,0.1809,0,0,180,103,-809.1);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-408.85,61.4);

	this.elem3 = new lib.Megan_Side_Angry_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(250.5,304.8,0.181,0.181,0,0,0,236.2,-807.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem3},{t:this.elem1},{t:this.elem2},{t:this.elem4},{t:this.elem6},{t:this.elem5},{t:this.elem7}]}).wait(1));

	// Layer_3
	this.instance = new lib.BG_Door();
	this.instance.setTransform(-667,-1054);

	this.instance_1 = new lib.Ground_Iso();
	this.instance_1.setTransform(672.9,-491,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SceneDialog3cutscene, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.SceneDialog2cutscene = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem7 = new lib.Plant_4();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-404.5,954.7);

	this.timeline.addTween(cjs.Tween.get(this.elem7).wait(1));

	// Layer_2
	this.elem2 = new lib.James_Side_01();
	this.elem2.name = "elem2";
	this.elem2.setTransform(199.15,472.35,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-342.4,108.95);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem2}]}).wait(1));

	// Layer_3
	this.elem9 = new lib.Door1();
	this.elem9.name = "elem9";
	this.elem9.setTransform(518.75,194.9);

	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(-276.6,-264.6);

	this.elem6 = new lib.Plant_3();
	this.elem6.name = "elem6";
	this.elem6.setTransform(31.55,-184.3);

	this.elem5 = new lib.Plant_2();
	this.elem5.name = "elem5";
	this.elem5.setTransform(105.55,-209.95);

	this.elem4 = new lib.Plant_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(22.05,-255.3);

	this.elem3 = new lib.Kastje_1();
	this.elem3.name = "elem3";
	this.elem3.setTransform(71.4,30.1);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(672.9,-491,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem3},{t:this.elem4},{t:this.elem5},{t:this.elem6},{t:this.elem8},{t:this.elem9}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SceneDialog2cutscene, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.SceneDialog1cutscene = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem6 = new lib.Plant_5();
	this.elem6.name = "elem6";
	this.elem6.setTransform(-420.1,942.75,0.81,0.81);

	this.elem5 = new lib.Extra_Side_Seated_01();
	this.elem5.name = "elem5";
	this.elem5.setTransform(395.75,740.1,1,1,0,0,180);

	this.elem1 = new lib.Scene1_Table_1();
	this.elem1.name = "elem1";
	this.elem1.setTransform(32.85,405.7);

	this.elem4 = new lib.Extra1_Side_01();
	this.elem4.name = "elem4";
	this.elem4.setTransform(392.25,408.75,0.1809,0.181,0,0,0,0,0.6);

	this.elem3 = new lib.Megan_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(219.65,308.2,0.181,0.181);

	this.elem2 = new lib.Robert_Side_01();
	this.elem2.name = "elem2";
	this.elem2.setTransform(59.35,208.1,0.181,0.181);

	this.elem5_1 = new lib.Gambit();
	this.elem5_1.name = "elem5_1";
	this.elem5_1.setTransform(-313.55,220.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem5_1},{t:this.elem2},{t:this.elem3},{t:this.elem4},{t:this.elem1},{t:this.elem5},{t:this.elem6}]}).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(672.95,-491,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SceneDialog1cutscene, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Scene4_intro = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.elem7 = new lib.stool();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-114.7,668.4,0.8189,0.7598);

	this.elem8 = new lib.stool();
	this.elem8.name = "elem8";
	this.elem8.setTransform(109.65,846.2,0.8189,0.7598);

	this.elem2 = new lib.chai_1();
	this.elem2.name = "elem2";
	this.elem2.setTransform(-237.75,94.3,0.6667,0.6667,0,0,0,48.1,77.5);

	this.elem9 = new lib.Plant_5();
	this.elem9.name = "elem9";
	this.elem9.setTransform(-513.1,1054.4,0.81,0.81);

	this.elem9_1 = new lib.board();
	this.elem9_1.name = "elem9_1";
	this.elem9_1.setTransform(305,-105.35,0.7197,0.7197);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-352.6,206.15);

	this.elem7_1 = new lib.stool();
	this.elem7_1.name = "elem7_1";
	this.elem7_1.setTransform(493.65,763,0.8189,0.7598);

	this.elem3 = new lib.bigtable();
	this.elem3.name = "elem3";
	this.elem3.setTransform(195,409.95,0.841,0.841,0,0,0,79.5,-12);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem3},{t:this.elem7_1},{t:this.elem1},{t:this.elem9_1},{t:this.elem9},{t:this.elem2},{t:this.elem8},{t:this.elem7}]}).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(672.9,-441,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Scene4_intro, new cjs.Rectangle(-734.2,-1184.2,1813.6000000000001,2288), null);


(lib.Robert_surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.Robert_Front_Relieved();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer_3
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_surprised, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Robert_sad = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Robert_Front_Sad();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_sad, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Robert_neutral = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.Robert_Front_Neutral();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer_3
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_neutral, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Robert_angry = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Robert_Front_Anger();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer_3
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_angry, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Officewindow_smoothie = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_9
	this.elem4 = new lib.smoothie();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-350.75,517.4,0.85,0.85,0,0,0,67,58.1);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_2
	this.elem3 = new lib.Gambit();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-269.1,621.65,1.1498,1.1498,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem3).wait(1));

	// Layer_8
	this.elem12 = new lib.curtains_1();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-285.9,101.9);

	this.timeline.addTween(cjs.Tween.get(this.elem12).wait(1));

	// Layer_7
	this.elem5 = new lib.desk01();
	this.elem5.name = "elem5";
	this.elem5.setTransform(459.55,436.25,0.8386,0.8386);

	this.instance = new lib.officeviewfloor();
	this.instance.setTransform(-666,127);

	this.elem8 = new lib.window_1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(-293.2,60.15,0.7856,0.7856);

	this.instance_1 = new lib.officeviewfloor();
	this.instance_1.setTransform(-666,227);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.elem8},{t:this.instance},{t:this.elem5}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-100);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Officewindow_smoothie, new cjs.Rectangle(-667.5,-1184.2,1746.9,2244.2), null);


(lib.Officewindow_nodrink = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem3 = new lib.Gambit();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-269.1,621.65,1.1498,1.1498,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem3).wait(1));

	// Layer_8
	this.elem9 = new lib.desk01();
	this.elem9.name = "elem9";
	this.elem9.setTransform(459.55,436.25,0.8386,0.8386);

	this.elem10 = new lib.dustbin2();
	this.elem10.name = "elem10";
	this.elem10.setTransform(163.45,159.35,0.5715,0.5715,0,0,0,119.5,145);

	this.elem12 = new lib.curtains_1();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-277.9,101.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem12},{t:this.elem10},{t:this.elem9}]}).wait(1));

	// Layer_7
	this.instance = new lib.officeviewfloor();
	this.instance.setTransform(-666,227);

	this.instance_1 = new lib.officeviewfloor();
	this.instance_1.setTransform(-666,127);

	this.elem11 = new lib.window_1();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-293.2,60.15,0.7856,0.7856);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-100);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Officewindow_nodrink, new cjs.Rectangle(-667.5,-1184.2,1746.9,2244.2), null);


(lib.Officewindow_espresso = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_9
	this.elem4 = new lib.espresso_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-372.8,480.4,0.6295,0.6295,0,0,0,67,58.1);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_2
	this.elem3 = new lib.Gambit();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-269.1,621.65,1.1498,1.1498,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem3).wait(1));

	// Layer_8
	this.elem9 = new lib.desk01();
	this.elem9.name = "elem9";
	this.elem9.setTransform(459.55,436.25,0.8386,0.8386);

	this.elem10 = new lib.dustbin2();
	this.elem10.name = "elem10";
	this.elem10.setTransform(163.45,159.35,0.5715,0.5715,0,0,0,119.5,145);

	this.elem12 = new lib.curtains_1();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-277.9,101.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem12},{t:this.elem10},{t:this.elem9}]}).wait(1));

	// Layer_7
	this.instance = new lib.officeviewfloor();
	this.instance.setTransform(-666,227);

	this.instance_1 = new lib.officeviewfloor();
	this.instance_1.setTransform(-666,127);

	this.elem11 = new lib.window_1();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-293.2,60.15,0.7856,0.7856);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-100);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Officewindow_espresso, new cjs.Rectangle(-667.5,-1184.2,1746.9,2244.2), null);


(lib.Officewindow_chai = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_9
	this.elem4 = new lib.chai_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-377.2,392.6,0.6864,0.6864,0,0,0,67,58.1);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_2
	this.elem3 = new lib.Gambit();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-269.1,521.65,1.1498,1.1498,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem3).wait(1));

	// Layer_8
	this.elem10 = new lib.desk01();
	this.elem10.name = "elem10";
	this.elem10.setTransform(459.55,336.25,0.8386,0.8386);

	this.elem11 = new lib.dustbin2();
	this.elem11.name = "elem11";
	this.elem11.setTransform(163.45,59.35,0.5715,0.5715,0,0,0,119.5,145);

	this.elem12 = new lib.curtains_1();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-285.9,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem12},{t:this.elem11},{t:this.elem10}]}).wait(1));

	// Layer_7
	this.instance = new lib.officeviewfloor();
	this.instance.setTransform(-666,127);

	this.instance_1 = new lib.officeviewfloor();
	this.instance_1.setTransform(-666,27);

	this.elem11_1 = new lib.window_1();
	this.elem11_1.name = "elem11_1";
	this.elem11_1.setTransform(-293.2,-39.85,0.7856,0.7856);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11_1},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// floor
	this.instance_2 = new lib.officeviewfloor();
	this.instance_2.setTransform(-666,227);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-200);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Officewindow_chai, new cjs.Rectangle(-667.5,-1184.2,1746.9,2244.2), null);


(lib.OfficeRobert1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem11 = new lib.Plant_5();
	this.elem11.name = "elem11";
	this.elem11.setTransform(545.75,962.5);

	this.timeline.addTween(cjs.Tween.get(this.elem11).wait(1));

	// Layer_2
	this.elem3 = new lib.Robert_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(61.55,498.9,0.181,0.181,0,0,0,0.3,0.3);

	this.elem1 = new lib.GambitBack();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-320.4,664.3,0.9249,0.9249,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem3}]}).wait(1));

	// Layer_3
	this.elem5 = new lib.Kastje_1();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-535.5,367.7,0.8344,0.8344,0,0,180);

	this.elem7 = new lib.watercooler();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-179.55,-237.3,0.8462,0.8462,0,0,180);

	this.elem9 = new lib.Door1();
	this.elem9.name = "elem9";
	this.elem9.setTransform(8.9,-26.3,1,1,0,0,180);

	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(316.65,-204.7,1,1,0,0,180);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,-411,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem8},{t:this.elem9},{t:this.elem7},{t:this.elem5}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OfficeRobert1, new cjs.Rectangle(-785,-1184.2,1864.4,2318), null);


(lib.OfficeMegan1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem2 = new lib.GambitBack();
	this.elem2.name = "elem2";
	this.elem2.setTransform(-126.2,618.55,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem2).wait(1));

	// Layer_9
	this.elem4 = new lib.Megan_Side_Angry_01();
	this.elem4.name = "elem4";
	this.elem4.setTransform(298.05,313.45,0.2029,0.2029,0,0,0,80.4,-643.4);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_7
	this.elem7 = new lib.desk01();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-468.1,307.65,0.8386,0.8386,0,0,180);

	this.instance = new lib.watercoolerfloor01();
	this.instance.setTransform(-667,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem7}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OfficeMegan1, new cjs.Rectangle(-832.5,-1184.2,1911.9,2239.2), null);


(lib.Mission3CutScene1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem7 = new lib.Plant_5();
	this.elem7.name = "elem7";
	this.elem7.setTransform(441.25,942.75,0.81,0.81);

	this.elem5 = new lib.Conf2_1();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-36.7,489.6);

	this.elem6 = new lib.Conf1_1();
	this.elem6.name = "elem6";
	this.elem6.setTransform(15.15,389.55);

	this.elem4 = new lib.SmallTable_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-20.95,657.15);

	this.elem2 = new lib.Robert_Side_Sad();
	this.elem2.name = "elem2";
	this.elem2.setTransform(-266.2,304.6,0.1809,0.1809,0,0,180,103,-809.1);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-408.85,61.4);

	this.elem3 = new lib.Megan_Side_Angry_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(250.5,304.8,0.181,0.181,0,0,0,236.2,-807.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem3},{t:this.elem1},{t:this.elem2},{t:this.elem4},{t:this.elem6},{t:this.elem5},{t:this.elem7}]}).wait(1));

	// Layer_3
	this.instance = new lib.BG_Door();
	this.instance.setTransform(-667,-1054);

	this.instance_1 = new lib.Ground_Iso();
	this.instance_1.setTransform(672.9,-491,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Mission3CutScene1, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.Megan_surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Megan_Front_Frustrated();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_surprised, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Megan_sad = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Megan_Front_Disappointed();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_sad, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Megan_neutral = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Megan_Front_Neutral();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_neutral, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Megan_angry = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Megan_Front_Angry();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Megan_angry, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Meetingroom5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem5 = new lib.Conf2_1();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-245.05,125.55);

	this.elem6 = new lib.Conf1_1();
	this.elem6.name = "elem6";
	this.elem6.setTransform(-193.2,25.5);

	this.elem4 = new lib.SmallTable_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-229.3,293.1);

	this.elem5_1 = new lib.wine_1();
	this.elem5_1.name = "elem5_1";
	this.elem5_1.setTransform(-193.6,508.2,0.5839,0.5839,0,0,0,67,111.5);

	this.elem6_1 = new lib.wine_1();
	this.elem6_1.name = "elem6_1";
	this.elem6_1.setTransform(96,620.3,0.5839,0.5839,0,0,0,61.5,136.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem6_1},{t:this.elem5_1},{t:this.elem4},{t:this.elem6},{t:this.elem5}]}).wait(1));

	// Layer_3
	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(297.6,259.2);

	this.elem10 = new lib.Flags_1();
	this.elem10.name = "elem10";
	this.elem10.setTransform(-686,-1068.4);

	this.elem7 = new lib.Plant_5();
	this.elem7.name = "elem7";
	this.elem7.setTransform(448.15,865.95,0.81,0.81);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-335.3,621.2);

	this.elem3 = new lib.Ellis_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(103.25,499.4,0.181,0.181,0,0,0,236.2,-807.9);

	this.instance = new lib.watercoolerfloor01();
	this.instance.setTransform(-667,13);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem3},{t:this.elem1},{t:this.elem7},{t:this.elem10},{t:this.elem8}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Meetingroom5, new cjs.Rectangle(-686,-1184.2,1765.4,2240.2), null);


(lib.Meetingroom4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.elem4 = new lib.SmallTable_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-229.3,293.1);

	this.elem6 = new lib.Plant_5();
	this.elem6.name = "elem6";
	this.elem6.setTransform(448.15,865.95,0.81,0.81);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-335.3,621.2);

	this.elem3 = new lib.Ellis_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(103.25,499.4,0.181,0.181,0,0,0,236.2,-807.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem3},{t:this.elem1},{t:this.elem6},{t:this.elem4}]}).wait(1));

	// Layer_3
	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(297.6,259.2);

	this.instance = new lib.watercoolerfloor01();
	this.instance.setTransform(-667,13);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem8}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Meetingroom4, new cjs.Rectangle(-667.5,-1184.2,1746.9,2240.2), null);


(lib.Meetingroom3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.elem7 = new lib.stool();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-114.7,668.4,0.8189,0.7598);

	this.elem8 = new lib.stool();
	this.elem8.name = "elem8";
	this.elem8.setTransform(109.65,846.2,0.8189,0.7598);

	this.elem13 = new lib.Plant_5();
	this.elem13.name = "elem13";
	this.elem13.setTransform(-513.1,1054.4,0.81,0.81);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-352.6,206.15);

	this.elem9 = new lib.stool();
	this.elem9.name = "elem9";
	this.elem9.setTransform(493.65,763,0.8189,0.7598);

	this.elem5 = new lib.bigtable();
	this.elem5.name = "elem5";
	this.elem5.setTransform(20.8,477.85,0.841,0.841);

	this.elem3 = new lib.Megan_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(364.5,233.25,0.181,0.181,0,0,0,236.2,-807.9);

	this.elem2 = new lib.Robert_Side_01();
	this.elem2.name = "elem2";
	this.elem2.setTransform(136.1,113.3,0.1809,0.1809,0,0,0,103,-809.1);

	this.elem11 = new lib.board();
	this.elem11.name = "elem11";
	this.elem11.setTransform(305,-105.35,0.7197,0.7197);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11},{t:this.elem2},{t:this.elem3},{t:this.elem5},{t:this.elem9},{t:this.elem1},{t:this.elem13},{t:this.elem8},{t:this.elem7}]}).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(672.9,-441,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Meetingroom3, new cjs.Rectangle(-734.2,-1184.2,1813.6000000000001,2288), null);


(lib.MC_BG1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_8
	this.elem13 = new lib.Profits();
	this.elem13.name = "elem13";
	this.elem13.setTransform(236.35,-25.35,0.8637,0.8637);

	this.timeline.addTween(cjs.Tween.get(this.elem13).wait(1));

	// Layer_6
	this.elem12 = new lib.dustbin2();
	this.elem12.name = "elem12";
	this.elem12.setTransform(71.65,663.35,0.7312,0.7312,0,0,0,98,118.7);

	this.timeline.addTween(cjs.Tween.get(this.elem12).wait(1));

	// Layer_7
	this.elem11 = new lib.deskGambit();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-86.05,463.75,0.7608,0.7608,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.elem11).wait(1));

	// floor
	this.instance = new lib.watercoolerfloor01();
	this.instance.setTransform(-667,13);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MC_BG1, new cjs.Rectangle(-691.3,-1184.2,1770.7,2240.2), null);


(lib.James_surprised_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(341.4,176.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.James_Front_Surprised();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_surprised_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.James_sad_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(341.4,176.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.James_Front_Disappointed();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_sad_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.James_neutral_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(341.4,176.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.James_Front_01();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_neutral_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.James_angry_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(341.4,176.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.James_Front_Frustrated();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.James_angry_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.IntrospectionCloseUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_17 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(17).call(this.frame_17).wait(1));

	// Layer_4
	this.instance = new lib.gambitZoomAnim();
	this.instance.setTransform(-106.2,563.75,0.229,0.229);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:-0.2,regY:0.2,scaleX:0.4661,scaleY:0.4661,x:-222.8,y:865},17,cjs.Ease.quadOut).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(18));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-691.3,-1184.2,1770.7,2575.8);


(lib.Introspection_BG2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_9
	this.elem4 = new lib.cappuccino_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-395.95,487.75,0.85,0.85,0,0,0,67,58.1);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_2
	this.elem3 = new lib.Gambit();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-269.1,611.65,1.1498,1.1498,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem3).wait(1));

	// Layer_8
	this.elem12 = new lib.curtains_1();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-285.9,91.9);

	this.timeline.addTween(cjs.Tween.get(this.elem12).wait(1));

	// Layer_7
	this.elem8 = new lib.desk01();
	this.elem8.name = "elem8";
	this.elem8.setTransform(459.55,426.25,0.8386,0.8386);

	this.elem9 = new lib.dustbin2();
	this.elem9.name = "elem9";
	this.elem9.setTransform(163.45,149.35,0.5715,0.5715,0,0,0,119.5,145);

	this.instance = new lib.officeviewfloor();
	this.instance.setTransform(-666,117);

	this.elem11 = new lib.window_1();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-293.2,50.15,0.7856,0.7856);

	this.instance_1 = new lib.officeviewfloor();
	this.instance_1.setTransform(-666,227);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.elem11},{t:this.instance},{t:this.elem9},{t:this.elem8}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-110);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Introspection_BG2, new cjs.Rectangle(-667.5,-1184.2,1746.9,2244.2), null);


(lib.Introspection_BG1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_9
	this.elem4 = new lib.cappuccino_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-407.2,532.9,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_2
	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-243.3,661.85,1.383,1.383,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.elem1).wait(1));

	// Layer_4
	this.elem9 = new lib.watercooler();
	this.elem9.name = "elem9";
	this.elem9.setTransform(361,205.2,0.8669,0.8669,0,0,0,151,313.2);

	this.elem11 = new lib.Plant_5();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-457.3,308.55,0.7349,0.7349);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11},{t:this.elem9}]}).wait(1));

	// Layer_6
	this.elem7 = new lib.dustbin();
	this.elem7.name = "elem7";
	this.elem7.setTransform(164.05,240.75,0.9178,0.9178,0,0,0,98,118.7);

	this.timeline.addTween(cjs.Tween.get(this.elem7).wait(1));

	// floor
	this.instance = new lib.watercoolerfloor01();
	this.instance.setTransform(-667,11);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Introspection_BG1, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.HallwayRobert1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem11 = new lib.Plant_5();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-434.15,986.55);

	this.timeline.addTween(cjs.Tween.get(this.elem11).wait(1));

	// Layer_2
	this.elem3 = new lib.Robert_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(6.25,543.55,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(319.5,324.2,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem3}]}).wait(1));

	// Layer_3
	this.elem7 = new lib.watercooler();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-180.75,-249.3,0.8462,0.8462,0,0,0,151,313.3);

	this.elem8 = new lib.Kastje_1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(-462.5,-262.75,0.8344,0.8344);

	this.elem5 = new lib.Doo2();
	this.elem5.name = "elem5";
	this.elem5.setTransform(418.35,220);

	this.elem6 = new lib.Door1();
	this.elem6.name = "elem6";
	this.elem6.setTransform(110.6,41.6);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(672.9,-411,1.0037,1.0037,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem6},{t:this.elem5},{t:this.elem8},{t:this.elem7}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HallwayRobert1, new cjs.Rectangle(-707.1,-1184.2,1786.5,2318), null);


(lib.Ellis_surprised_wine = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.wine_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Asking();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_surprised_wine, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_surprised_water = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.water_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Asking();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_surprised_water, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_surprised_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(425.95,162.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Asking();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_surprised_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Ellis_Front_Asking();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_surprised, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_neutral_wine = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.wine_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_01();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_neutral_wine, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_neutral_water = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.water_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_01();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_neutral_water, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_neutral_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(425.95,162.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_01();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_neutral_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_neutral = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Ellis_Front_01();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_neutral, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_happy_wine = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.wine_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Surprised();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_happy_wine, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_happy_water = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.water_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Surprised();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_happy_water, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_happy_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(425.95,162.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Surprised();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_happy_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_happy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Ellis_Front_Surprised();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_happy, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_angry_wine = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.wine_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Annoyed();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_angry_wine, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_angry_water = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// water
	this.instance_1 = new lib.water_1();
	this.instance_1.setTransform(382.4,125.55,0.7398,0.7398,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Annoyed();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_angry_water, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_angry_coffee = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// coffee
	this.instance_1 = new lib.coffee_1();
	this.instance_1.setTransform(425.95,162.7,1,1,0,0,0,67,58);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Actor
	this.instance_2 = new lib.Ellis_Front_Annoyed();
	this.instance_2.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Floor
	this.instance_3 = new lib.Ground_Straight();
	this.instance_3.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_angry_coffee, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.Ellis_angry = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Actor
	this.instance_1 = new lib.Ellis_Front_Annoyed();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Floor
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Ellis_angry, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.ElevatorEllis3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem11 = new lib.Plant_5();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-505.85,584.95,0.7349,0.7349);

	this.elem7 = new lib.Plant_5();
	this.elem7.name = "elem7";
	this.elem7.setTransform(115.3,197.5,0.723,0.723,0,0,0,0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem7},{t:this.elem11}]}).wait(1));

	// Layer_2
	this.elem3 = new lib.Ellis_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(8.5,611.1,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(343.85,490.55,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem3}]}).wait(1));

	// Layer_3
	this.elem5 = new lib.Elevator();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-265.05,266.65,0.7625,0.8163,0,0,2.4004);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,-271,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem5}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ElevatorEllis3, new cjs.Rectangle(-706.5,-1184.2,1785.9,2458), null);


(lib.ElevatorEllis1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem11 = new lib.Plant_5();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-416.25,744.95,0.7349,0.7349);

	this.elem7 = new lib.Plant_4();
	this.elem7.name = "elem7";
	this.elem7.setTransform(217.7,133.5,0.723,0.723,0,0,0,0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem7},{t:this.elem11}]}).wait(1));

	// Layer_2
	this.elem3 = new lib.Ellis_Side_01();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-42.7,479.65,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(356.65,487.1,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem3}]}).wait(1));

	// Layer_3
	this.elem5 = new lib.Elevator();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-265.05,266.65,0.7625,0.8163,0,0,2.4004);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,-271,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem5}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ElevatorEllis1, new cjs.Rectangle(-667.5,-1184.2,1746.9,2458), null);


(lib.Cutscene_BG3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_7
	this.instance = new lib.factory4();
	this.instance.setTransform(-152.3,550.75,0.7767,0.7767,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Cutscene_BG3, new cjs.Rectangle(-691.3,-1184.2,1770.7,2340.4), null);


(lib.Cutscene_BG2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_8
	this.elem12 = new lib.curtains_1();
	this.elem12.name = "elem12";
	this.elem12.setTransform(-285.9,129.45);

	this.timeline.addTween(cjs.Tween.get(this.elem12).wait(1));

	// Layer_7
	this.elem9 = new lib.desk01();
	this.elem9.name = "elem9";
	this.elem9.setTransform(459.55,436.25,0.8386,0.8386);

	this.elem10 = new lib.dustbin2();
	this.elem10.name = "elem10";
	this.elem10.setTransform(163.45,159.35,0.5715,0.5715,0,0,0,119.5,145);

	this.instance = new lib.officeviewfloor();
	this.instance.setTransform(-666,127);

	this.elem11 = new lib.window_1();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-293.2,60.15,0.7856,0.7856);

	this.instance_1 = new lib.officeviewfloor();
	this.instance_1.setTransform(-666,227);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.elem11},{t:this.instance},{t:this.elem10},{t:this.elem9}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-100);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Cutscene_BG2, new cjs.Rectangle(-667.5,-1184.2,1746.9,2244.2), null);


(lib.Cutscene_BG1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem9 = new lib.watercooler();
	this.elem9.name = "elem9";
	this.elem9.setTransform(361,205.2,0.8669,0.8669,0,0,0,151,313.2);

	this.elem11 = new lib.Plant_5();
	this.elem11.name = "elem11";
	this.elem11.setTransform(-457.3,308.55,0.7349,0.7349);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem11},{t:this.elem9}]}).wait(1));

	// Layer_6
	this.elem7 = new lib.dustbin();
	this.elem7.name = "elem7";
	this.elem7.setTransform(164.05,240.75,0.9178,0.9178,0,0,0,98,118.7);

	this.timeline.addTween(cjs.Tween.get(this.elem7).wait(1));

	// floor
	this.instance = new lib.watercoolerfloor01();
	this.instance.setTransform(-667,11);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Cutscene_BG1, new cjs.Rectangle(-667.5,-1184.2,1746.9,2239.2), null);


(lib.CofffeeEllis3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem7 = new lib.Plant_4();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-439.45,1030.15);

	this.timeline.addTween(cjs.Tween.get(this.elem7).wait(1));

	// Layer_2
	this.elem13 = new lib.coffee_1();
	this.elem13.name = "elem13";
	this.elem13.setTransform(156.65,260.4,0.7062,0.7062,0,0,0,59,61.6);

	this.elem2 = new lib.Ellis_Side_01();
	this.elem2.name = "elem2";
	this.elem2.setTransform(39.6,347.15,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.GambitBack();
	this.elem1.name = "elem1";
	this.elem1.setTransform(444.3,513.8,0.8458,0.8458);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem2},{t:this.elem13}]}).wait(1));

	// Layer_3
	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(8,-4.7,1,1,0,0,180);

	this.elem5 = new lib.Plant_2();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-344.65,-73.8,1,1,0,0,180);

	this.elem4 = new lib.Plant_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-261.15,-119.15,1,1,0,0,180);

	this.elem3 = new lib.coffeemachine_1();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-380.5,133);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,-391,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem3},{t:this.elem4},{t:this.elem5},{t:this.elem8}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CofffeeEllis3, new cjs.Rectangle(-701.4,-1184.2,1780.8000000000002,2338), null);


(lib.CoffeeJames = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem7 = new lib.Plant_4();
	this.elem7.name = "elem7";
	this.elem7.setTransform(-465.05,838.15);

	this.timeline.addTween(cjs.Tween.get(this.elem7).wait(1));

	// Layer_2
	this.elem13 = new lib.coffee_1();
	this.elem13.name = "elem13";
	this.elem13.setTransform(156.65,491.6,0.7062,0.7062,0,0,0,59,61.6);

	this.elem2 = new lib.James_Side_01();
	this.elem2.name = "elem2";
	this.elem2.setTransform(41.65,572.35,0.181,0.181,0,0,180,0.3,0.3);

	this.elem1 = new lib.Gambit();
	this.elem1.name = "elem1";
	this.elem1.setTransform(356.65,367.1,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem2},{t:this.elem13}]}).wait(1));

	// Layer_3
	this.elem8 = new lib.Door1();
	this.elem8.name = "elem8";
	this.elem8.setTransform(107,-64.2,1,1,0,0,180);

	this.elem5 = new lib.Plant_2();
	this.elem5.name = "elem5";
	this.elem5.setTransform(-344.65,-73.8,1,1,0,0,180);

	this.elem4 = new lib.Plant_1();
	this.elem4.name = "elem4";
	this.elem4.setTransform(-261.15,-119.15,1,1,0,0,180);

	this.elem3 = new lib.coffeemachine_1();
	this.elem3.name = "elem3";
	this.elem3.setTransform(-281.5,73.5);

	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,-391,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.elem3},{t:this.elem4},{t:this.elem5},{t:this.elem8}]}).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CoffeeJames, new cjs.Rectangle(-727,-1184.2,1806.4,2338), null);


// stage content:
(lib.DialogScenes_RTL = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// scenes
	this.instance = new lib.Officewindow_nodrink();
	this.instance.setTransform(-7547,5393.45,1,1,0,0,0,-2,6);

	this.instance_1 = new lib.Officewindow_smoothie();
	this.instance_1.setTransform(-4278.8,10775.75,1,1,0,0,0,-2,6);

	this.instance_2 = new lib.Meetingroom5();
	this.instance_2.setTransform(-9428.6,3184.3,1,1,0,0,0,-2,6);

	this.instance_3 = new lib.Meetingroom4();
	this.instance_3.setTransform(-7790.2,3184.3,1,1,0,0,0,-2,6);

	this.instance_4 = new lib.Scene4_intro();
	this.instance_4.setTransform(-2877.55,8018.4,1,1,0,0,0,-2,6);

	this.instance_5 = new lib.CofffeeEllis3();
	this.instance_5.setTransform(-8200.1,7968.4,1,1,0,0,0,-2,6);

	this.instance_6 = new lib.ElevatorEllis3();
	this.instance_6.setTransform(-6600.8,7848.4,1,1,0,0,0,-2,6);

	this.instance_7 = new lib.Officewindow_chai();
	this.instance_7.setTransform(-4278.8,8062.15,1,1,0,0,0,-2,6);

	this.instance_8 = new lib.WaterEllis2();
	this.instance_8.setTransform(-1442.95,8466.75,1,1,0,0,0,-2,6);

	this.instance_9 = new lib.Meetingroom3();
	this.instance_9.setTransform(383.2,7979.5,1,1,0,0,0,-2,6);

	this.instance_10 = new lib.Officewindow_espresso();
	this.instance_10.setTransform(-1147,5393.45,1,1,0,0,0,-2,6);

	this.instance_11 = new lib.ElevatorEllis1();
	this.instance_11.setTransform(-6086.75,2964.3,1,1,0,0,0,-2,6);

	this.instance_12 = new lib.CoffeeJames();
	this.instance_12.setTransform(-2546.05,809.25,1,1,0,0,0,-2,6);

	this.instance_13 = new lib.OfficeRobert1();
	this.instance_13.setTransform(-9224.95,5313.7,1,1,0,0,0,-2,6);

	this.instance_14 = new lib.OfficeMegan1();
	this.instance_14.setTransform(-5941.3,5393.45,1,1,0,0,0,-2,6);

	this.instance_15 = new lib.HallwayRobert1();
	this.instance_15.setTransform(-968.7,809.25,1,1,0,0,0,-2,6);

	this.instance_16 = new lib.IntrospectionCloseUp();
	this.instance_16.setTransform(-6142.1,809.25,1,1,0,0,0,-2,6);

	this.instance_17 = new lib.Cutscene_BG3();
	this.instance_17.setTransform(-4278.8,-1841.1,1,1,0,0,0,-2,6);

	this.instance_18 = new lib.Ellis_neutral_wine();
	this.instance_18.setTransform(13774.4,8407.8,1,1,0,0,0,-2,6);

	this.instance_19 = new lib.Ellis_happy_wine();
	this.instance_19.setTransform(8778.95,8407.8,1,1,0,0,0,-2,6);

	this.instance_20 = new lib.Ellis_angry_wine();
	this.instance_20.setTransform(12136,8407.8,1,1,0,0,0,-2,6);

	this.instance_21 = new lib.Ellis_surprised_wine();
	this.instance_21.setTransform(10529.75,8407.8,1,1,0,0,0,-2,6);

	this.instance_22 = new lib.Ellis_neutral_coffee();
	this.instance_22.setTransform(7016,11459.35,1,1,0,0,0,-2,6);

	this.instance_23 = new lib.Ellis_happy_coffee();
	this.instance_23.setTransform(2020.55,11459.35,1,1,0,0,0,-2,6);

	this.instance_24 = new lib.Ellis_angry_coffee();
	this.instance_24.setTransform(5377.6,11459.35,1,1,0,0,0,-2,6);

	this.instance_25 = new lib.Ellis_surprised_coffee();
	this.instance_25.setTransform(3771.35,11459.35,1,1,0,0,0,-2,6);

	this.instance_26 = new lib.Ellis_neutral_water();
	this.instance_26.setTransform(7016,8407.8,1,1,0,0,0,-2,6);

	this.instance_27 = new lib.Ellis_happy_water();
	this.instance_27.setTransform(2020.55,8407.8,1,1,0,0,0,-2,6);

	this.instance_28 = new lib.Ellis_angry_water();
	this.instance_28.setTransform(5377.6,8407.8,1,1,0,0,0,-2,6);

	this.instance_29 = new lib.Ellis_surprised_water();
	this.instance_29.setTransform(3771.35,8407.8,1,1,0,0,0,-2,6);

	this.instance_30 = new lib.MC_BG1();
	this.instance_30.setTransform(-4278.8,809.25,1,1,0,0,0,-2,6);

	this.instance_31 = new lib.Introspection_BG2();
	this.instance_31.setTransform(-4278.8,5393.45,1,1,0,0,0,-2,6);

	this.instance_32 = new lib.Cutscene_BG2();
	this.instance_32.setTransform(-2817.1,5393.45,1,1,0,0,0,-2,6);

	this.instance_33 = new lib.Introspection_BG1();
	this.instance_33.setTransform(-4278.8,3064.3,1,1,0,0,0,-2,6);

	this.instance_34 = new lib.Cutscene_BG1();
	this.instance_34.setTransform(-2817.1,3064.3,1,1,0,0,0,-2,6);

	this.instance_35 = new lib.Mission3CutScene1();
	this.instance_35.setTransform(-1147,3064.3,1,1,0,0,0,-2,6);

	this.instance_36 = new lib.Ellis_neutral();
	this.instance_36.setTransform(7016,5335.8,1,1,0,0,0,-2,6);

	this.instance_37 = new lib.Megan_neutral();
	this.instance_37.setTransform(7016,3064.3,1,1,0,0,0,-2,6);

	this.instance_38 = new lib.James_neutral_coffee();
	this.instance_38.setTransform(7016,809.25,1,1,0,0,0,-2,6);

	this.instance_39 = new lib.SceneDialog5cutscene();
	this.instance_39.setTransform(-1064.9,-1379.25,1,1,0,0,0,-1.2,1);

	this.instance_40 = new lib.Robert_neutral();
	this.instance_40.setTransform(7016,-1374.25,1,1,0,0,0,-2,6);

	this.instance_41 = new lib.Ellis_happy();
	this.instance_41.setTransform(2020.55,5335.8,1,1,0,0,0,-2,6);

	this.instance_42 = new lib.Megan_angry();
	this.instance_42.setTransform(2020.55,3064.3,1,1,0,0,0,-2,6);

	this.instance_43 = new lib.Ellis_angry();
	this.instance_43.setTransform(5377.6,5335.8,1,1,0,0,0,-2,6);

	this.instance_44 = new lib.Ellis_surprised();
	this.instance_44.setTransform(3771.35,5335.8,1,1,0,0,0,-2,6);

	this.instance_45 = new lib.Megan_sad();
	this.instance_45.setTransform(5377.6,3064.3,1,1,0,0,0,-2,6);

	this.instance_46 = new lib.Megan_surprised();
	this.instance_46.setTransform(3771.35,3064.3,1,1,0,0,0,-2,6);

	this.instance_47 = new lib.James_sad_coffee();
	this.instance_47.setTransform(5377.6,809.25,1,1,0,0,0,-2,6);

	this.instance_48 = new lib.James_surprised_coffee();
	this.instance_48.setTransform(3691.05,809.25,1,1,0,0,0,-2,6);

	this.instance_49 = new lib.Robert_surprised();
	this.instance_49.setTransform(5377.6,-1374.25,1,1,0,0,0,-2,6);

	this.instance_50 = new lib.Robert_angry();
	this.instance_50.setTransform(3691.05,-1374.25,1,1,0,0,0,-2,6);

	this.instance_51 = new lib.SceneDialog4cutscene();
	this.instance_51.setTransform(538,5335.8,1,1,0,0,0,-2,6);

	this.instance_52 = new lib.SceneDialog3cutscene();
	this.instance_52.setTransform(538,3064.3,1,1,0,0,0,-2,6);

	this.instance_53 = new lib.SceneDialog2cutscene();
	this.instance_53.setTransform(538,809.25,1,1,0,0,0,-2,6);

	this.instance_54 = new lib.James_angry_coffee();
	this.instance_54.setTransform(2020.55,809.25,1,1,0,0,0,-2,6);

	this.instance_55 = new lib.Robert_sad();
	this.instance_55.setTransform(2020.55,-1374.25,1,1,0,0,0,-2,6);

	this.instance_56 = new lib.SceneDialog1cutscene();
	this.instance_56.setTransform(538.8,-1379.25,1,1,0,0,0,-1.2,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-9572.6,-2687.1,24022,15900.5);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#0F97FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/DialogScenes_RTL/Andrea_Side_Neutral_Closed.png", id:"DialogScenes_RTL_Andrea_Side_Neutral_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Andrea_Side_Neutral_Open.png", id:"DialogScenes_RTL_Andrea_Side_Neutral_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Background_Blue.png", id:"DialogScenes_RTL_Background_Blue", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/BG_Door.png", id:"DialogScenes_RTL_BG_Door", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/BIGTABLE.png", id:"DialogScenes_RTL_BIGTABLE", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/BOARD.png", id:"DialogScenes_RTL_BOARD", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/cappuccino.png", id:"DialogScenes_RTL_cappuccino", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/chai.png", id:"DialogScenes_RTL_chai", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/CharacterShadow.png", id:"DialogScenes_RTL_CharacterShadow", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/closedDoor.png", id:"DialogScenes_RTL_closedDoor", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/coffee.png", id:"DialogScenes_RTL_coffee", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/coffeemachine.png", id:"DialogScenes_RTL_coffeemachine", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Conf1.png", id:"DialogScenes_RTL_Conf1", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Conf2.png", id:"DialogScenes_RTL_Conf2", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Couch.png", id:"DialogScenes_RTL_Couch", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/curtains.png", id:"DialogScenes_RTL_curtains", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/deskfront.png", id:"DialogScenes_RTL_deskfront", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/deskGambit2.png", id:"DialogScenes_RTL_deskGambit2", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/dustbin01.png", id:"DialogScenes_RTL_dustbin01", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/dustbin02.png", id:"DialogScenes_RTL_dustbin02", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Element1.png", id:"DialogScenes_RTL_Element1", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Element3.png", id:"DialogScenes_RTL_Element3", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Element4.png", id:"DialogScenes_RTL_Element4", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/elevator.png", id:"DialogScenes_RTL_elevator", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/espresso.png", id:"DialogScenes_RTL_espresso", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Extra1_Back.png", id:"DialogScenes_RTL_Extra1_Back", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Extra1_Side_Back.png", id:"DialogScenes_RTL_Extra1_Side_Back", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Extra_Side_Closed.png", id:"DialogScenes_RTL_Extra_Side_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Extra_Side_Open.png", id:"DialogScenes_RTL_Extra_Side_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Extra_Side_Seated.png", id:"DialogScenes_RTL_Extra_Side_Seated", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Eye_Front_Open.png", id:"DialogScenes_RTL_Eye_Front_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/factory4b.png", id:"DialogScenes_RTL_factory4b", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Flags.png", id:"DialogScenes_RTL_Flags", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/gambit.png", id:"DialogScenes_RTL_gambit", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Gambit_Back.png", id:"DialogScenes_RTL_Gambit_Back", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/gambit_closed.png", id:"DialogScenes_RTL_gambit_closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/gambitanim3x.png", id:"DialogScenes_RTL_gambitanim3x", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/gambitanimeyes3x.png", id:"DialogScenes_RTL_gambitanimeyes3x", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/gambitback.png", id:"DialogScenes_RTL_gambitback", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/GREENPOSTITS.png", id:"DialogScenes_RTL_GREENPOSTITS", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Ground_Iso.png", id:"DialogScenes_RTL_Ground_Iso", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Ground_Straight.png", id:"DialogScenes_RTL_Ground_Straight", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/james.png", id:"DialogScenes_RTL_james", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/James_Side_Neutral_Closed.png", id:"DialogScenes_RTL_James_Side_Neutral_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Kastje.png", id:"DialogScenes_RTL_Kastje", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Man1_Brow.png", id:"DialogScenes_RTL_Man1_Brow", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Man1_Front_Base.png", id:"DialogScenes_RTL_Man1_Front_Base", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Man2_Brow.png", id:"DialogScenes_RTL_Man2_Brow", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Man2_Front_Base.png", id:"DialogScenes_RTL_Man2_Front_Base", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Man2_Moustache.png", id:"DialogScenes_RTL_Man2_Moustache", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/megan.png", id:"DialogScenes_RTL_megan", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Megan_Side_Angry_Closed.png", id:"DialogScenes_RTL_Megan_Side_Angry_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Megan_Side_Angry_Open.png", id:"DialogScenes_RTL_Megan_Side_Angry_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Megan_Side_Neutral_Closed.png", id:"DialogScenes_RTL_Megan_Side_Neutral_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Megan_Side_Sitting_Closed.png", id:"DialogScenes_RTL_Megan_Side_Sitting_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Megan_Side_Sitting_Open.png", id:"DialogScenes_RTL_Megan_Side_Sitting_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/officeviewfloor.png", id:"DialogScenes_RTL_officeviewfloor", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/openDoor.png", id:"DialogScenes_RTL_openDoor", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/PAPER.png", id:"DialogScenes_RTL_PAPER", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Plant1.png", id:"DialogScenes_RTL_Plant1", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Plant2.png", id:"DialogScenes_RTL_Plant2", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Plant3.png", id:"DialogScenes_RTL_Plant3", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Plant4.png", id:"DialogScenes_RTL_Plant4", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Plant5.png", id:"DialogScenes_RTL_Plant5", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/profits.png", id:"DialogScenes_RTL_profits", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/robert.png", id:"DialogScenes_RTL_robert", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Robert_Side_Neutral_Closed.png", id:"DialogScenes_RTL_Robert_Side_Neutral_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Robert_Side_Sad_Closed.png", id:"DialogScenes_RTL_Robert_Side_Sad_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Robert_Side_Sad_Open.png", id:"DialogScenes_RTL_Robert_Side_Sad_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Robert_Side_Sitting_Closed.png", id:"DialogScenes_RTL_Robert_Side_Sitting_Closed", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Robert_Side_Sitting_Open.png", id:"DialogScenes_RTL_Robert_Side_Sitting_Open", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Scene1_Table.png", id:"DialogScenes_RTL_Scene1_Table", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Shadow_Front.png", id:"DialogScenes_RTL_Shadow_Front", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/SmallTable.png", id:"DialogScenes_RTL_SmallTable", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/smoothy.png", id:"DialogScenes_RTL_smoothy", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Spot_01.png", id:"DialogScenes_RTL_Spot_01", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Spot_02.png", id:"DialogScenes_RTL_Spot_02", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/STOOL.png", id:"DialogScenes_RTL_STOOL", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Table_Empty.png", id:"DialogScenes_RTL_Table_Empty", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/water.png", id:"DialogScenes_RTL_water", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/watercooler01.png", id:"DialogScenes_RTL_watercooler01", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/watercoolerfloor01.png", id:"DialogScenes_RTL_watercoolerfloor01", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/window.png", id:"DialogScenes_RTL_window", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/wine.png", id:"DialogScenes_RTL_wine", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Woman1_Brow.png", id:"DialogScenes_RTL_Woman1_Brow", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Woman1_Front_Base.png", id:"DialogScenes_RTL_Woman1_Front_Base", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Woman2_Brow.png", id:"DialogScenes_RTL_Woman2_Brow", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/Woman2_Front_Base.png", id:"DialogScenes_RTL_Woman2_Front_Base", bundle:"DialogScenes_RTL"},
		{src:"assets/skins/images/DialogScenes_RTL/YELLOWPOSTIS.png", id:"DialogScenes_RTL_YELLOWPOSTIS", bundle:"DialogScenes_RTL"}
	],
	preloads: []
};



})(lib.DialogScenes_RTL = {}, images, ss, createjs);
module.exports = lib.DialogScenes_RTL;